import { Outlet } from 'react-router-dom';
import Menu from './Menu';
import Balance from '../../features/wallet/components/Balance';
import TutorialOverlay from '../../features/tutorial/components/TutorialOverlay';

/**
 * Общий каркас экранов с нижним меню.
 *
 * Выносит дублировавшиеся ранее в каждой странице `<Balance />` и `<Menu />`
 * на один уровень выше — страница рендерится в `<Outlet />` между ними.
 * Благодаря этому верхняя панель баланса и нижнее меню расположены
 * единообразно на всех экранах.
 *
 * @param {boolean} showBalance - рендерить ли панель баланса (по умолчанию true).
 *        BattlePass использует собственную шапку, поэтому баланс ему не нужен.
 */
export default function AppLayout({ showBalance = true }) {
  return (
    <div className="app-layout">
      {showBalance && (
        <div className="balance-wrapper">
          <Balance />
        </div>
      )}

      <div className="app-layout__content">
        <Outlet />
      </div>

      <Menu />

      {/* Подсказки туториала поверх страниц с меню (шаги — features/tutorial/tutorialSteps.js) */}
      <TutorialOverlay />
    </div>
  );
}
